import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { BasicKeyValuePair } from "@components/for_drawer/BasicKeyValuePair";
import { BasicTwoParagraphs } from "@components/for_drawer/BasicTwoParagraphs";

import { EntityType, Relationship, RelationshipType } from "@resource/models";

import { formatterShort } from "@utils/time-utils";

import { OwnerKeyLinkPair } from "./OwnerKeyLinkPair";

interface Props {
  data: Relationship[];
}

export const SectionRelationship: FC<Props> = ({ data }) => {
  const content: ReactNode[] = [];

  const { t } = useTranslation(undefined, {
    keyPrefix: "resource"
  });

  if (data?.length) {
    for (const r of data) {
      const isReallyOwner =
        r.entityType === EntityType.Organization &&
        r.relationshipType === RelationshipType.Owner;

      if (isReallyOwner) {
        content.push(
          <OwnerKeyLinkPair
            key={`key-${r.entityId}-${r.entityType}`}
            relationship={r}
          />,
          <BasicKeyValuePair
            key={`key-${r.entityId}-${r.createdOn}`}
            baseKey={t("drawer.labels.ownerRelationCreatedAt")}
            baseValue={formatterShort(r.createdOn)}
          />
        );
      } else {
        content.push(
          <BasicKeyValuePair
            key={`key-${r.entityId}-${r.entityType}`}
            baseKey={`${r.entityType} (${r.relationshipType})`}
            baseValue={r.entityName ? `${r.entityName}` : "N/A"}
          />
        );
      }
    }
  }

  return content?.length > 0 ? (
    content
  ) : (
    <BasicTwoParagraphs text={"No relationship info"} />
  );
};
